'use client'
import { useTranslations } from 'next-intl'
import React, { PropsWithChildren, useCallback, useState } from 'react'
import { LoadingWithContainer } from '../../Loaders'
import LoadMoreButton from '../../LoadMoreButton/loadMoreButton'
import { NoData } from '../Elements'
import styles from '../Elements/styles.module.scss'
import { useBody } from './useBody'

interface MobileDataTableProps {
  data: any[]
  loading?: boolean
  rowComponent: any
  itemsInPage?: number
  loadMoreClick: () => void
  totalCount?: number
}

const MobileDataTableWithPagination: React.FC<MobileDataTableProps> = ({
  itemsInPage = 20,
  data,
  loading,
  rowComponent,
  loadMoreClick,
  totalCount,
}: PropsWithChildren<MobileDataTableProps>) => {
  const t = useTranslations('translation')

  const body = useBody({ data, rowComponent })

  return (
    <div>
      {data.length === 0 ? <NoData>{t('noData')}</NoData> : body}

      {!!totalCount && totalCount > itemsInPage && (
        <div className={styles.loadMoreWrap}>
          <LoadMoreButton onClick={loadMoreClick} loading={loading}>
            {t('loadMore')}
          </LoadMoreButton>
        </div>
      )}
    </div>
  )
}

export default MobileDataTableWithPagination
